define('rss',['jquery', 'event-manager'], function($, eventManager) {
    'use strict';

    eventManager.on('e24-rss-customize-loaded', function() {
        var $form = $('.create-rss-feed');
        var $labels = $form.find('label');
        var $inputs = $form.find('input, select');

        function buildUrl() {
            var formData = $form.serializeArray();
            var data = {};

            $.each(formData, function() {
                if (data[this.name] !== undefined) {
                    data[this.name] += ',' + this.value;
                } else {
                    data[this.name] = this.value;
                }
            });

            var url = '/rss?categories=' + (data.categories || '') + '&tags=' + (data.tags || '') + '&limit=' + (data.limit || '');

            $form.attr('action', url);
        }

        $labels.find('input:checked').parent().addClass('checked');
        buildUrl();

        $labels.click(function() {
            var $this = $(this);
            if ($this.find('input').is(':checked')) {
                $this.addClass('checked');
            } else {
                $this.removeClass('checked');
            }
        });

        $inputs.change(function() {
            buildUrl();
        });

        $form.submit(function(e) {
            if (!$('input.private').is(':checked')) {
                e.preventDefault();
                $('#privateError').removeClass('hidden');
                return false;
            }
        });
    });
});

